module.exports = __webpack_public_path__ + "img/1018_pc.5aa9b196.gif";